package com.trevorwiebe.timesheet.mileage.presentation

import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.trevorwiebe.timesheet.core.presentation.common.botPadding

@Composable
actual fun MileageTopBarAddAction(onClick: () -> Unit) {}

@Composable
actual fun MileageFab(onClick: () -> Unit) {
    val bottomPadding = botPadding()
    FloatingActionButton(
        onClick = onClick,
        modifier = Modifier
            .padding(bottom = 16.dp, end = 16.dp)
            .offset(y = -bottomPadding),
        containerColor = MaterialTheme.colorScheme.tertiary,
        contentColor = MaterialTheme.colorScheme.onTertiary
    ) {
        Icon(Icons.Default.Add, contentDescription = "Add entry")
    }
}
